import styled from 'styled-components';
import { H2 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getCreateWizardForecastTypeGoalsUrl } from '../../../utils/urls';
import { useCallback, useMemo } from 'react';
import { TRACK_CLOSE_WIZARD_AND_CREATE_GOAL } from '../../../constants/ForecastType';
import PortalIdParser from 'PortalIdParser';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DescriptionWrapper = styled.div.withConfig({
  displayName: "StepTwo__DescriptionWrapper",
  componentId: "sc-1sp64qn-0"
})(["width:460px;"]);
const StepTwo = ({
  closeWizardAndTrack,
  forecastTypeId
}) => {
  var _window;
  const portalId = PortalIdParser.get();
  const baseAppURL = getFullUrlWithCurrentSubDomain();
  const location = (_window = window) === null || _window === void 0 ? void 0 : _window.location;
  const createNewGoalHref = useMemo(() => getCreateWizardForecastTypeGoalsUrl({
    forecastTypeId,
    portalId,
    baseAppURL,
    location
  }), [baseAppURL, forecastTypeId, location, portalId]);
  const handleOnClick = useCallback(() => {
    closeWizardAndTrack(TRACK_CLOSE_WIZARD_AND_CREATE_GOAL);
  }, [closeWizardAndTrack]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "forecasting",
      width: 120,
      className: "m-bottom-4"
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createForecastTypeWizard.stepTwo.title"
      })
    }), /*#__PURE__*/_jsx(DescriptionWrapper, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-100",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "createForecastTypeWizard.stepTwo.description_jsx",
          options: {
            href: createNewGoalHref,
            external: true,
            onClick: handleOnClick
          },
          elements: {
            Link: UILink
          }
        })
      })
    })]
  });
};
export default StepTwo;